import { render } from "./ProgressBar.vue?vue&type=template&id=6f6779cf"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"
script.render = render

export default script